export default "__VITE_ASSET__BSnmUVwD__"